import {FormSection} from "base/component/form";
import {EDARFormOutrasInstalacionsFields, EDARFormDesenoFields} from ".";

const EDARExplotacionFormSection = () => {
    return (
        <>
            <FormSection title="Servicios auxiliares">
                <EDARFormOutrasInstalacionsFields />
            </FormSection>
            <FormSection title="Deseño">
                <EDARFormDesenoFields />
            </FormSection>
        </>
    );
};

export default EDARExplotacionFormSection;
